import { ANPREvent } from 'domain/anpr-event'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import MercosulPlate from 'shared/mercosul-plate/mercosul-license-plate'
import { getColorInfo } from './anpr-event-formatters'
import { getVehicleType } from '../util/getVehicleTypeTags'
import { isSpeedViolation } from '../util/speed-violation-filter'

interface ANPREventListItemProps {
  event: ANPREvent
  onViewDetails: (event: ANPREvent) => void
  onImageClick: (url: string) => void
  onExport: () => void
}

const ANPREventListItem = ({ event, onViewDetails, onImageClick, onExport }: ANPREventListItemProps) => {
  const date = new Date(event.createdDate)
  const colorInfo = getColorInfo(event.vehicleColor)
  const violation = isSpeedViolation(event)

  return (
    <div className='col-12'>
      <Card className='event-list-card'>
        <div className='grid'>
          <div className='col-12 md:col-3'>
            <div
              className='event-list-image'
              onClick={() => event.detectionImagePath && onImageClick(event.detectionImagePath)}
            >
              {event.detectionImagePath ? (
                <div className='event-image-wrapper'>
                  <img src={event.detectionImagePath} alt='Detecção' className='event-main-image' />
                  <div className='event-image-overlay'>
                    <i className='pi pi-search-plus' />
                  </div>
                </div>
              ) : (
                <div className='event-no-image'>
                  <i className='pi pi-image' />
                </div>
              )}
            </div>
          </div>

          <div className='col-12 md:col-6'>
            <div className='flex flex-column gap-3'>
              <div className='flex align-items-center gap-3'>
                <MercosulPlate licensePlate={event.licensePlate} size='S' />
                {getVehicleType(event.vehicleType)}
              </div>

              <div className='grid'>
                <div className='col-6'>
                  <div className='event-list-info'>
                    <i className='pi pi-calendar text-primary' />
                    <div>
                      <small className='text-muted block'>Data & Hora</small>
                      <span className='font-semibold'>{date.toLocaleDateString('pt-BR')}</span>
                      <br />
                      <span className='text-sm'>{date.toLocaleTimeString('pt-BR')}</span>
                    </div>
                  </div>
                </div>

                <div className='col-6'>
                  <div className='event-list-info'>
                    <i className='pi pi-video text-primary' />
                    <div>
                      <small className='text-muted block'>Câmera</small>
                      <span className='font-semibold'>{event.cameraName}</span>
                    </div>
                  </div>
                </div>

                <div className='col-6'>
                  <div className='event-list-info'>
                    <i className='pi pi-palette text-primary' />
                    <div>
                      <small className='text-muted block'>Cor</small>
                      <span className='font-semibold flex align-items-center gap-2'>
                        <span className='event-color-indicator' style={{ backgroundColor: colorInfo.color }} />
                        {colorInfo.label}
                      </span>
                    </div>
                  </div>
                </div>

                {event.speed > 0 && (
                  <div className='col-6'>
                    <div className='event-list-info'>
                      <i className='pi pi-gauge' style={violation ? { color: 'var(--red-500)' } : { color: 'var(--primary-color)' }} />
                      <div>
                        <small className='text-muted block'>Velocidade</small>
                        <span className='font-semibold' style={violation ? { color: 'var(--red-500)' } : undefined}>
                          {event.speed} km/h
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='col-12 md:col-3 flex align-items-center justify-content-center'>
            <div className='flex flex-column gap-2 w-full'>
              <Button
                icon='pi pi-eye'
                label='Ver Detalhes'
                className='p-button-sm w-full'
                onClick={() => onViewDetails(event)}
              />
              <Button
                icon='pi pi-download'
                label='Baixar'
                className='p-button-sm p-button-outlined w-full'
                onClick={onExport}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ANPREventListItem